module.exports = __webpack_public_path__ + "static/media/plant-force.fd8a1700.png";